class LimitlessProductTabs extends HTMLElement {
  connectedCallback() {
    this.panels = [...this.querySelectorAll('[data-limitless-panel]')];
    this.tablist = this.querySelector('[data-limitless-tablist]');

    if (!this.tablist || this.panels.length === 0) return;

    this.tablist.replaceChildren();

    this.panels.forEach((panel, index) => {
      const tab = document.createElement('button');
      tab.id = `${panel.id}-Tab`;
      tab.className = 'limitless-tabs__tab';
      tab.type = 'button';
      tab.role = 'tab';
      tab.textContent = panel.dataset.tabLabel || 'Colección';
      tab.setAttribute('aria-selected', String(index === 0));
      tab.setAttribute('aria-controls', panel.id);
      tab.tabIndex = index === 0 ? 0 : -1;
      tab.dataset.limitlessTab = '';
      panel.removeAttribute('aria-label');
      panel.setAttribute('aria-labelledby', tab.id);
      this.tablist.append(tab);
    });

    this.tabs = [...this.querySelectorAll('[data-limitless-tab]')];
    this.tablist.hidden = false;
    this.dataset.enhanced = '';

    this.addEventListener('click', this.handleClick);
    this.addEventListener('keydown', this.handleKeydown);
    this.addEventListener('pointerover', this.handleTabIntent);
    this.addEventListener('focusin', this.handleTabIntent);
    document.addEventListener('shopify:block:select', this.handleBlockSelect);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
    this.removeEventListener('keydown', this.handleKeydown);
    this.removeEventListener('pointerover', this.handleTabIntent);
    this.removeEventListener('focusin', this.handleTabIntent);
    document.removeEventListener('shopify:block:select', this.handleBlockSelect);
  }

  getPanelForTab(tab) {
    const panelId = tab?.getAttribute('aria-controls');

    return panelId ? this.panels.find((panel) => panel.id === panelId) : null;
  }

  hydratePanel(panel) {
    const template = panel?.querySelector('[data-limitless-panel-template]');
    if (!template) return;

    template.replaceWith(template.content.cloneNode(true));
    panel.dataset.limitlessPanelLoaded = '';
  }

  activate(tab, moveFocus = false) {
    if (!tab) return;

    this.hydratePanel(this.getPanelForTab(tab));

    this.tabs.forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.id !== tab.getAttribute('aria-controls');
    });

    if (moveFocus) tab.focus();
  }

  handleTabIntent = (event) => {
    const tab = event.target.closest('[data-limitless-tab]');
    if (!tab || !this.contains(tab)) return;

    this.hydratePanel(this.getPanelForTab(tab));
  };

  handleClick = (event) => {
    const tab = event.target.closest('[data-limitless-tab]');
    if (!tab || !this.contains(tab)) return;

    this.activate(tab);
  };

  handleKeydown = (event) => {
    const current = event.target.closest('[data-limitless-tab]');
    if (!current || !this.contains(current)) return;

    const currentIndex = this.tabs.indexOf(current);
    let nextIndex;

    if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.tabs.length - 1;
    if (nextIndex === undefined) return;

    event.preventDefault();
    this.activate(this.tabs[nextIndex], true);
  };

  handleBlockSelect = (event) => {
    if (!this.contains(event.target)) return;

    const panel = event.target.closest?.('[data-limitless-panel]');
    const tabId = panel?.getAttribute('aria-labelledby');
    const tab = tabId ? this.querySelector(`#${CSS.escape(tabId)}`) : null;

    this.activate(tab);
  };
}

if (!customElements.get('limitless-product-tabs')) {
  customElements.define('limitless-product-tabs', LimitlessProductTabs);
}
